"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.imagePropType = exports.featureBlockPropType = exports.dataType = exports.ctaPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _text = require("@mmc/text");

var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});

exports.imagePropType = imagePropType;

var featureBlockPropType = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  title: _propTypes["default"].string,
  image: imagePropType,
  description: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
}));

exports.featureBlockPropType = featureBlockPropType;

var ctaPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  priority: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool,
  icon: _propTypes["default"].string
});

exports.ctaPropType = ctaPropType;

var dataType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  heading1: _propTypes["default"].string,
  backgroundImage: imagePropType,
  textBlock: _propTypes["default"].string,
  featureBlock: featureBlockPropType,
  cta: ctaPropType,
  disclaimerData: _text.disclaimerDataPropTypes
});

exports.dataType = dataType;